import * as _ from "lodash";
import {DashboardChannel} from "../models/DashboardChannel";
import {CachingCollection} from "./_BaseCollection";

export interface DashboardCollectionOptions {
    dashboardId: number,
    gaugeTypeId?: number,
    modulesIds?: string[],
    tabId?: number;
    channelIds?: number[];
}

export class DashboardChannelCollection extends CachingCollection<DashboardChannel> {

    urlRoot = '/api/v1/dashboards/channels';
    dashboardId: number;
    gaugeTypeId: number;
    modulesIds: string[];
    tabId?: number;
    channelIds?: number[];

    url = () => {
        var url = '/api/v1/dashboards/' + (this.dashboardId ? this.dashboardId + '/' : '') + 'channels';
        var params = [];
        if (this.channelIds && this.channelIds.length) {
            params.push('channelIds=' + this.channelIds.join(','));
        } else if (this.tabId) {
            params.push('tabId=' + this.tabId);
        }
        if (params.length) {
            url += '?' + params.join('&');
        }
        return url;
    };

    urlSupportedGaugeTypes = () => {
        return '/api/v1/dashboards/gaugetypes';
    };

    constructor(initialModels?: Object[] | any[], options?: DashboardCollectionOptions) {
        super(initialModels, _.extend({model: DashboardChannel}, options));
        if (!options) return;
        this.dashboardId = options.dashboardId;
        this.gaugeTypeId = options.gaugeTypeId;
        this.modulesIds = options.modulesIds;
        this.tabId = options.tabId;
        this.channelIds = options.channelIds;
    }

    comparator = (model) => {
        return model.get('order');
    }
}



// WEBPACK FOOTER //
// ./srv/public/js/collections/DashboardChannels.ts